const financialReturnedChecks = [
  {
    path: '/financial/returned_checks',
    redirect: { name: 'ReturnedChecksToConfirm' },
    name: 'ReturnedChecks',
    meta: { 
      auth: true, 
      roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics', 'Seller', 'CreditAnalyst'],
    },
    component: () => import('@/_backoffice/_financial/components/returned_checks/ReturnedChecks'),
    children: [
      {
        meta: { 
          auth: true, 
          roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics', 'Seller', 'CreditAnalyst'],
        },
        path: 'to_confirm',
        name: 'ReturnedChecksToConfirm',
        component: () => import('@/_backoffice/_financial/components/returned_checks/ReturnedChecksToConfirm')
      },
      {
        meta: { 
          auth: true, 
          roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics', 'Seller', 'CreditAnalyst'],
        },
        path: 'in_hands',
        name: 'ReturnedChecksInHands',
        component: () => import('@/_backoffice/_financial/components/returned_checks/ReturnedChecksInHands')
      },
      {
        meta: { 
          auth: true, 
          roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics', 'Seller', 'CreditAnalyst'],
        },
        path: 'completed',
        name: 'ReturnedChecksConcluded',
        component: () => import('@/_backoffice/_financial/components/returned_checks/ReturnedChecksConcluded')
      }
    ]
  }
]

export default financialReturnedChecks
